import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { documentNumberRegex } from 'src/app/data/constants/Data';
import { UserInformation } from 'src/app/shared/models/app-models';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();
  headerString: string = 'Procure & Pay';
  destroy$: Subject<boolean> = new Subject<boolean>();
  loggedInUser!: UserInformation;
  
  search = {
    query: '',
  };

  constructor(private router: Router, private store: Store<{
    user: UserInformation;
  }>,) {
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserInformation) => {
        this.loggedInUser = user;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  onSearchSubmit() {
    let data = { docId: this.search.query };

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/search'], { queryParams: data })
    );
    this.router
      .navigateByUrl('/redirect', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl(url));
  }

  toggleMenu() {
    this.menuToggle.emit();
  }

  navigateToLandingPage() {
    this.router.navigateByUrl('/land');
  }
  goUserGuideURL() {
    const url = environment.mmsuserguideURL;
    window.open(url, '_blank');
  }
  goToFAQ(){
    const url = environment.faq;
    window.open(url, '_blank');
  }
}
